module.exports = __webpack_public_path__ + "static/media/ubicacion.5542c7e9.svg";